import { BannerSliderProps } from "@omni/types/components/props/bannerSlider.props";
import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { BannerSliderContextProvider } from "./context/bannerSlider.context";

const Base = ({
    bannerSlides,
    delay,
    speed,
    trackingProps,
    children
}: RequireChildrenFor<BannerSliderProps>) => {
    return (
        <BannerSliderContextProvider
            delay={delay}
            speed={speed}
            slides={bannerSlides}
            trackingProps={trackingProps}
        >
            {children}
        </BannerSliderContextProvider>
    );
};

export { Base };
